import React, { Fragment, FunctionComponent } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { SecondaryButton } from "Shared/Buttons";
import styled from "styled-components";

export const Btn = styled(SecondaryButton)`
    ${(props) => props.theme.breakpoints.up("desktop")} {
        width: 50%;
    }
`;

const ButtonContainer = styled("div")`
    display: flex;
    flex-direction: column;
    margin-top: 1em;

    ${(props) => props.theme.breakpoints.up("desktop")} {
        align-items: flex-start;
        flex-direction: row;
        flex-wrap: wrap;
    }
`;

const SkipOption = styled("div")`
    cursor: pointer;
    flex: 0 0 100%;
    font-weight: bold;
    margin: 20px 0 0;
    text-decoration: underline;
`;

interface CreditOrSkipProps {
    onGoToCreditApp: () => void;
    onSkipForNow: () => void;
}

const CreditOrSkip: FunctionComponent<CreditOrSkipProps & WithTranslation> = ({ onSkipForNow, onGoToCreditApp, t }) => {
    return (
        <Fragment>
            <p className="StepOne__title">{t("ContinueDeal.StepOne.CreditOrSkip.title")}</p>
            <p className="StepOne__text">{t("ContinueDeal.StepOne.CreditOrSkip.description")}</p>

            <ButtonContainer>
                <div className="StepOne__primary-container">
                    <Btn onClick={onGoToCreditApp}>{t("ContinueDeal.StepOne.CreditOrSkip.getCreditButtonLabel")}</Btn>
                </div>
                <div className="StepOne__secondary-container">
                    <SkipOption className="StepOne__secondary-action" onClick={onSkipForNow}>
                        {t("ContinueDeal.StepOne.CreditOrSkip.skipButtonLabel")}
                    </SkipOption>
                </div>
            </ButtonContainer>
        </Fragment>
    );
};

export default withTranslation()(CreditOrSkip);
